import { EnumBusinessState } from './Generated';
import { type BadgeVariations, SelectOption } from '@synqo/frontend-component-library';

export const getEnumBusinessStateLabel = (value: EnumBusinessState) => {
    switch (value) {
        case EnumBusinessState.Active:
            return 'Aktiv';
        case EnumBusinessState.Inactive:
            return 'Inaktiv';
        case EnumBusinessState.Locked:
            return 'Gesperrt';
        default:
            return 'Nicht definiert';
    }
};

export const enumBusinessStateOptions: SelectOption<EnumBusinessState>[] = [
    { name: 'active', label: getEnumBusinessStateLabel(EnumBusinessState.Active), value: EnumBusinessState.Active },
    {
        name: 'inactive',
        label: getEnumBusinessStateLabel(EnumBusinessState.Inactive),
        value: EnumBusinessState.Inactive,
    },
    {
        name: 'locked',
        label: getEnumBusinessStateLabel(EnumBusinessState.Locked),
        value: EnumBusinessState.Locked,
    },
];

export const getBadgeVariantByBusinessState = (value: EnumBusinessState): BadgeVariations => {
    switch (value) {
        case EnumBusinessState.Active:
            return 'success';
        case EnumBusinessState.Inactive:
            return 'info';
        case EnumBusinessState.Locked:
            return 'warning';
        default:
            return 'danger';
    }
};
